// extracted by mini-css-extract-plugin
export var bypassLinks = "layout-module--bypassLinks--658e1";
export var footer = "layout-module--footer--e1719";
export var globalWrapper = "layout-module--globalWrapper--47afd";
export var gradientHeader = "layout-module--gradientHeader--21e6b";
export var header = "layout-module--header--395c7";